import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { FeatureToggle, SoftwareOptionsForCompany } from '@shared/enums';
import { combineLatest, Observable, of, switchMap } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { GlobalSettingsService } from './globalSettings.service';
import { SoftwareOptionsService } from '../core/companySoftwareOptions/service/softwareOptions.service';
import { FeaturesToggleSettingsService } from '../featuresToggleSettings/service/featuresToggleSettings.service';
import { FeatureToggleSettings } from '../featuresToggleSettings/featuresToggleSettings.model';
import { ApplicationNavigationService } from 'app/services/shell/application-navigation/application-navigation.service';

@Injectable({
	providedIn: 'root'
})
export class SoftwareOptionOrFeatureFlagsGuard  {
	constructor(
		private featuresToggleSettingsService: FeaturesToggleSettingsService,
		private globalSettingsService: GlobalSettingsService,
		private softwareOptionsService: SoftwareOptionsService,
		private applicationNavigationService: ApplicationNavigationService,
		private router: Router
	) { }

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean> {
				const supportedSoftwareOptions = next.data.softwareOptions as Array<SoftwareOptionsForCompany>;
				const companyId = this.globalSettingsService.get().selectedCompanyId;
				const roleType = this.globalSettingsService.rolePath();
				const featureFlag = next.data.feature as FeatureToggle;


				return combineLatest([
					this.softwareOptionsService.getCompanySoftwareOptions(companyId),
					this.featuresToggleSettingsService.getFeaturesToggleSettings()
				]).pipe(
					map(([companySoftwareOptions, featureFlags]) => {
						const swoExists = this.softwareOptionsService.areSoftwareOptionExist(supportedSoftwareOptions, companySoftwareOptions);
						const ffIsActive = featureFlags.some(f => f.id === String(featureFlag) && f.isActive);
						if (!swoExists && !ffIsActive) {
							this.applicationNavigationService.reset();
							this.router.navigate([`${roleType}/home`]);
						}
						return swoExists || ffIsActive;
					}),
					take(1)
				);
	}
}
